<template>
  <!--
  [ 네비 옵션 ]
  .mobile:nav-view
  .desktop:nav-view

  [ 도트 플로팅 옵션 ] 도트가 배너 이미지 "위에" 위치하게 됨.
  .dot-floating

  [ 배너 이미지 비율 ]
  .desktop:banner--16:9
  .desktop:banner--3:2
  .desktop:banner--4:3
  .desktop:banner--1:1
  .desktop:banner--3:4
  .desktop:banner--2:3

  .tablet:banner--16:9
  .tablet:banner--3:2
  .tablet:banner--4:3
  .tablet:banner--1:1
  .tablet:banner--3:4
  .tablet:banner--2:3

  .mobile:banner--16:9
  .mobile:banner--3:2
  .mobile:banner--4:3
  .mobile:banner--1:1
  .mobile:banner--3:4
  .mobile:banner--2:3

  [ 배너 고정 높이 ] *모바일은 비율만 제공 됨.
  .desktop:h--100px
  .desktop:h--200px
  .desktop:h--300px
  .desktop:h--400px
  .desktop:h--500px
  .desktop:h--600px
  .desktop:h--700px
  .desktop:h--800px

  [ Full bg 옵션 ]
  .full-bg

  -->
  <!-- :class="!$mobile ? 'banner__main -mb--100px' : '-mb--80px'" -->
  <carousel
    v-if="banners.normal.length > 0"
    class="user-banner -mb--3px"
    :class="themeClasses('banner')"
    :autoplay="true"
    :loop="true"
    :margin="0"
    :items="1"
    :center="false"
    :nav="true"
    :dots="true"
    :autoWidth="false"
    :autoHeight="false"
    :animateOut="'fadeOut'"
  >
    <div
      class=""
      v-for="banner in banners.normal"
      :key="banner.seq"
    >
      <!-- :class="!$mobile ? 'item' : ''" -->
      <a
        @mousedown.left="mousedown"
        @mouseup.left="open(banner, $event)"
        class="banner--img bg"
        :style="`background-image:url(/api/banners/files/${banner.uuid}/${banner.files[$mq === 'mobile' ? 1 : 0].fileName});`"
      >
        <!-- <div class="user-banner--content">
          <span>서브타이틀 위치 입니다.</span>
          <strong class="user-banner__title">대 타이틀 위치 입니다.</strong>
          <p class="user-banner__text">배너의 내용 위치 입니다.<p>
        </div> -->
      </a>
    </div>
  </carousel>
</template>

<script>
import carousel from 'vue-owl-carousel'
import theme from '@/component/js/theme'
import { mapState } from 'vuex'

export default {
  mixins: [theme],
  data () {
    return {
      position: {
        x: -1,
        y: -1
      }
    }
  },
  computed: {
    ...mapState(['banners'])
  },
  async created () {
    console.log('banners', this.banners)
    // try {
    //   const res = await this.$http.get('/api/banners', {
    //     params: { useFlag: 'Y' }
    //   })
    //   this.banners = res.data
    //   console.log('this.banners', this.banners)
    // } catch (ex) {
    // }
  },
  methods: {
    mousedown ($event) {
      this.position.x = $event.x
      this.position.y = $event.y
    },
    open (banner, $event) {
      if (this.position.x === $event.x && this.position.y === $event.y) {
        if (banner.newWindowFlag === 'Y') {
          window.open(banner.link, '_blank')
        } else {
          location.href = banner.link
        }
      }
      this.position.x = -1
      this.position.y = -1
    }
  },
  components: {
    carousel
  }
}
</script>
